import React from "react";
import successIcon from "../../assets/images/layout/successIcon.svg";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

const Unsubscript = () => {
  let navigate = useNavigate();
  return (
    <div className="inprogress">
      <div className="subsWrapper2">
        <div className="successBox">
          <div className="successIcon">
            <img src={successIcon} alt="wellness" className="img-fluid" />
          </div>
          <div className="successCont">
            <h6>{t("unsubscription.title")}</h6>
          </div>
        </div>
        <div className="plnaBtn">
          <button onClick={() => navigate("/")}>Ok</button>
        </div>
      </div>
    </div>
  );
};

export default Unsubscript;
